export const productListLanguage = {
    en: {
        'Product List': 'Product List',
        'Search': 'Search',
        'Image': 'Image',
        'Group ID': 'Group ID',
        'Product ID': 'Product ID',
        'Product Name': 'Product Name',
        'Price': 'Price',
        'Description': 'Description',
        'Sort ID': 'Sort ID',
        'Status': 'Status',
        'Action': 'Action',
        'Sold out': 'Sold out',
        'In stock': 'In stock',
        'Out of stock': 'Out of stock',
        'Are you sure you want to delete this product?': 'Are you sure you want to delete this product?',
        'Product deleted successfully': 'Product deleted successfully',
        'Failed to delete product:': 'Failed to delete product:',
        'Failed to delete product. Please try again later.': 'Failed to delete product. Please try again later.',
        'Filter by Group': 'Filter by Group',
        'All': 'All',
        'Add Product': 'Add Product',
        'Add/Edit Product': 'Add/Edit Product',
        'Current Product Image': 'Current Product Image',
        'Upload Product Image': 'Upload Product Image',
        'Condiment Options': 'Condiment Options',
        'Select Condiment': 'Select Condiment',
        'Remove': 'Remove',
        'Add Condiment': 'Add Condiment',
        'You can select up to 5 items': 'You can select up to 5 items',
        'Failed to submit product. Please try again later.': 'Failed to submit product. Please try again later.',
        'Image uploaded successfully!': 'Image uploaded successfully!',
        'Submit': 'Submit',
        'Cancel': 'Cancel',
    },
    th: {
        'Product List': 'รายการสินค้า',
        'Search': 'ค้นหา',
        'Image': 'รูปภาพ',
        'Group ID': 'รหัสกลุ่ม',
        'Product ID': 'รหัสสินค้า',
        'Product Name': 'ชื่อสินค้า',
        'Price': 'ราคา',
        'Description': 'รายละเอียด',
        'Sort ID': 'ลำดับ',
        'Status': 'สถานะ',
        'Action': 'การกระทำ',
        'Sold out': 'สินค้าหมด',
        'In stock': 'มีสินค้า',
        'Out of stock': 'ไม่มีสินค้า',
        'Are you sure you want to delete this product?': 'คุณแน่ใจหรือไม่ว่าต้องการลบสินค้านี้?',
        'Product deleted successfully': 'ลบสินค้าสำเร็จ',
        'Failed to delete product:': 'ลบสินค้าไม่สำเร็จ:',
        'Failed to delete product. Please try again later.': 'ลบสินค้าไม่สำเร็จ กรุณาลองใหม่อีกครั้ง',
        'Filter by Group': 'กรองตามกลุ่ม',
        'All': 'ทั้งหมด',
        'Add Product': 'เพิ่มสินค้า',
        'Add/Edit Product': 'เพิ่ม/แก้ไขสินค้า',
        'Current Product Image': 'รูปภาพสินค้าปัจจุบัน',
        'Upload Product Image': 'อัปโหลดรูปภาพสินค้า',
        'Condiment Options': 'ตัวเลือกเครื่องปรุง',
        'Select Condiment': 'เลือกเครื่องปรุง',
        'Remove': 'ลบ',
        'Add Condiment': 'เพิ่มเครื่องปรุง',
        'You can select up to 5 items': 'สามารถเลือกได้สูงสุด 5 รายการ',
        'Failed to submit product. Please try again later.': 'บันทึกสินค้าไม่สำเร็จ กรุณาลองใหม่อีกครั้ง',
        'Image uploaded successfully!': 'อัปโหลดรูปภาพสำเร็จ!',
        'Submit': 'บันทึก',
        'Cancel': 'ยกเลิก',
    },
    cn: {
        'Product List': '产品列表',
        'Search': '搜索',
        'Image': '图片',
        'Group ID': '组ID',
        'Product ID': '产品ID',
        'Product Name': '产品名称',
        'Price': '价格',
        'Description': '描述',
        'Sort ID': '排序ID',
        'Status': '状态',
        'Action': '操作',
        'Sold out': '售罄',
        'In stock': '有货',
        'Out of stock': '无货',
        'Are you sure you want to delete this product?': '您确定要删除此产品吗？',
        'Product deleted successfully': '产品删除成功',
        'Failed to delete product:': '删除产品失败：',
        'Failed to delete product. Please try again later.': '删除产品失败，请稍后再试。',
        'Filter by Group': '按组过滤',
        'All': '全部',
        'Add Product': '添加产品',
        'Add/Edit Product': '添加/编辑产品',
        'Current Product Image': '当前产品图片',
        'Upload Product Image': '上传产品图片',
        'Condiment Options': '调味品选项',
        'Select Condiment': '选择调味品',
        'Remove': '移除',
        'Add Condiment': '添加调味品',
        'You can select up to 5 items': '最多可选择5项',
        'Failed to submit product. Please try again later.': '提交产品失败，请稍后再试。',
        'Image uploaded successfully!': '图片上传成功！',
        'Submit': '提交',
        'Cancel': '取消',
    },
    jp: {
        'Product List': '商品リスト',
        'Search': '検索',
        'Image': '画像',
        'Group ID': 'グループID',
        'Product ID': '商品ID',
        'Product Name': '商品名',
        'Price': '価格',
        'Description': '説明',
        'Sort ID': '並び順ID',
        'Status': 'ステータス',
        'Action': '操作',
        'Sold out': '売り切れ',
        'In stock': '在庫あり',
        'Out of stock': '在庫なし',
        'Are you sure you want to delete this product?': 'この商品を削除してもよろしいですか？',
        'Product deleted successfully': '商品が正常に削除されました',
        'Failed to delete product:': '商品削除に失敗しました：',
        'Failed to delete product. Please try again later.': '商品削除に失敗しました。後でもう一度お試しください。',
        'Filter by Group': 'グループでフィルター',
        'All': 'すべて',
        'Add Product': '商品を追加',
        'Add/Edit Product': '商品を追加/編集',
        'Current Product Image': '現在の商品画像',
        'Upload Product Image': '商品画像をアップロード',
        'Condiment Options': '調味料オプション',
        'Select Condiment': '調味料を選択',
        'Remove': '削除',
        'Add Condiment': '調味料を追加',
        'You can select up to 5 items': '最大5件まで選択できます',
        'Failed to submit product. Please try again later.': '商品の送信に失敗しました。後でもう一度お試しください。',
        'Image uploaded successfully!': '画像が正常にアップロードされました！',
        'Submit': '送信',
        'Cancel': 'キャンセル',
    },
    kr: {
        'Product List': '상품 목록',
        'Search': '검색',
        'Image': '이미지',
        'Group ID': '그룹 ID',
        'Product ID': '상품 ID',
        'Product Name': '상품명',
        'Price': '가격',
        'Description': '설명',
        'Sort ID': '정렬 ID',
        'Status': '상태',
        'Action': '동작',
        'Sold out': '품절',
        'In stock': '재고 있음',
        'Out of stock': '재고 없음',
        'Are you sure you want to delete this product?': '이 상품을 삭제하시겠습니까?',
        'Product deleted successfully': '상품이 성공적으로 삭제되었습니다',
        'Failed to delete product:': '상품 삭제 실패:',
        'Failed to delete product. Please try again later.': '상품 삭제 실패. 나중에 다시 시도해 주세요.',
        'Filter by Group': '그룹별 필터링',
        'All': '전체',
        'Add Product': '상품 추가',
        'Add/Edit Product': '상품 추가/편집',
        'Current Product Image': '현재 상품 이미지',
        'Upload Product Image': '상품 이미지 업로드',
        'Condiment Options': '조미료 옵션',
        'Select Condiment': '조미료 선택',
        'Remove': '삭제',
        'Add Condiment': '조미료 추가',
        'You can select up to 5 items': '최대 5개까지 선택할 수 있습니다',
        'Failed to submit product. Please try again later.': '상품 등록에 실패했습니다. 나중에 다시 시도해 주세요.',
        'Image uploaded successfully!': '이미지가 성공적으로 업로드되었습니다!',
        'Submit': '제출',
        'Cancel': '취소',
    }
}